import { render, staticRenderFns } from "./OhYesCard.vue?vue&type=template&id=4fd9fdae&scoped=true"
import script from "./OhYesCard.vue?vue&type=script&lang=js"
export * from "./OhYesCard.vue?vue&type=script&lang=js"
import style0 from "./OhYesCard.vue?vue&type=style&index=0&id=4fd9fdae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd9fdae",
  null
  
)

export default component.exports